// extracted by css-extract-rspack-plugin
var _1 = "src-components-RightBar-ChatHeader-ChatHeader-module__backButton-vkaj_x";
var _2 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeader-WxbkC4";
var _3 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderAvatar-wlRMD2";
var _4 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderEdit-zlRFPT";
var _5 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderInfo-UTYaWT";
var _6 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderMembers-AxoePe";
var _7 = "src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderUsername-HpWmmJ";
var _8 = "src-components-RightBar-ChatHeader-ChatHeader-module__defaultAvatar-OxWUGT";
var _9 = "src-components-RightBar-ChatHeader-ChatHeader-module__headerActionButton-XRTKF9";
var _a = "src-components-RightBar-ChatHeader-ChatHeader-module__headerActions-eiPWKC";
export { _1 as "backButton", _2 as "chatHeader", _3 as "chatHeaderAvatar", _4 as "chatHeaderEdit", _5 as "chatHeaderInfo", _6 as "chatHeaderMembers", _7 as "chatHeaderUsername", _8 as "defaultAvatar", _9 as "headerActionButton", _a as "headerActions" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"backButton\":\"src-components-RightBar-ChatHeader-ChatHeader-module__backButton-vkaj_x\",\"chatHeader\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeader-WxbkC4\",\"chatHeaderAvatar\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderAvatar-wlRMD2\",\"chatHeaderEdit\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderEdit-zlRFPT\",\"chatHeaderInfo\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderInfo-UTYaWT\",\"chatHeaderMembers\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderMembers-AxoePe\",\"chatHeaderUsername\":\"src-components-RightBar-ChatHeader-ChatHeader-module__chatHeaderUsername-HpWmmJ\",\"defaultAvatar\":\"src-components-RightBar-ChatHeader-ChatHeader-module__defaultAvatar-OxWUGT\",\"headerActionButton\":\"src-components-RightBar-ChatHeader-ChatHeader-module__headerActionButton-XRTKF9\",\"headerActions\":\"src-components-RightBar-ChatHeader-ChatHeader-module__headerActions-eiPWKC\"}";
        // 1752373455097
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  